<template>
  <div class="text-center">

      <v-dialog
          transition="dialog-bottom-transition"
          v-model="dialog"
          activator="parent"
          :hide-overlay="true"
          width="500px"
      >
        <v-card rounded="lg">
          <v-card-title class="justify-space-between">
            <div></div>
            <div>
              <h4>Входящий звонок</h4>
            </div>
            <v-btn icon @click="dialog = false" >
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row style="display:flex; justify-content:space-between;">
                <v-col
                    cols="6"
                    sm="6"
                    md="3"
                >
                  <label>Телефон <span style="color: #D53025">*</span></label>
                  <v-text-field
                      label="Телефон"
                      class="rounded-lg"
                      outlined
                      dense
                      readonly
                      v-text="client.telephone"
                      style="height: 30px;margin-top: 10px"
                  ></v-text-field>
                </v-col>

                <v-col
                v-if="client && client.client_id && (client.client_id !== undefined) && (client.client_id !== 'undefined') && client.client_id.length > 6"
                    cols="6"
                    sm="6"
                    md="3"
                >
 
                <router-link
                  
                          :to="{ name: 'CardClient', params: {client_id: client.client_id}}"
                          class="d-flex"
                          style="align-items: center; text-decoration: none; color: #000"
                      >
                       Профиль
                      </router-link>
             
                </v-col>
                
                <v-col
                  v-else
                    cols="6"
                    sm="6"
                    md="3"
                >
                <span @click="createDeal(client.telephone)">Новый клиент</span>
             
                </v-col>

                      
              </v-row>
              <v-row v-if="client.lastname || client.firstname || client.middlename">
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                >
                  <label>Фамилия</label>
                  <v-text-field
                      label="Фамилия"
                      class="rounded-lg"
                      outlined
                      readonly
                      v-text="client.lastname"
                      style="height: 30px;margin-top: 10px"
                  ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                >
                  <label>Имя <span style="color: #D53025">*</span></label>
                  <v-text-field
                      label="Имя"
                      class="rounded-lg"
                      outlined
                      dense
                      readonly
                      v-text="client.firstname"
                      style="height: 30px;margin-top: 10px"
                  ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                >
                  <label>Отчество</label>
                  <v-text-field
                      label="Отчество"
                      class="rounded-lg"
                      outlined
                      dense
                      readonly
                      v-text="client.middlename"
                      style="height: 30px;margin-top: 10px"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

  </div>
</template>

<script>
//import {mapState} from "vuex";
import {monitorActionTypes} from '@/store/modules/monitor';
//import {getItem, setItem} from "../helpers/persistanceStorage";

export default {
  name: "CallInPopup",
  props: [
      'client',
      'client_id'
  ],
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    createDeal(phone) {
      let type = 'Продажа'
  
      this.$store.dispatch(monitorActionTypes.getListDeal, {
        type
      })
          .then((response) => {
            if (response.monitor.length === 1) {
              this.$router.push({ name: 'CreateClient', params: { deal: response.monitor[0],client_phone: phone } })
            }
          });
    },
    show() {
      this.dialog = true;
    },
    hide() {
      this.dialog = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.v-dialog__content {
width:500px !important;
height:auto !important;
bottom:0 !important;
right:0 !important;
top: unset !important;
left: unset !important;
}
</style>